import {FC, useMemo, useState} from 'react';
//formik
import {Field, useFormikContext} from 'formik';
//form configuration
import {LoginFormValues} from '../formConfiguration';
//mui
import {Box, IconButton, InputAdornment} from '@mui/material';
//constants
import {END, FIELD, FIELD_LABEL, FORM, LOG_IN, PASSWORD, PLACEHOLDER, STANDARD, TEXT} from '@/utils/constants';
//icons
import {ReactComponent as EyeSlashIcon} from '@/assets/icons/eye-slash.svg';
import {ReactComponent as EyeIcon} from '@/assets/icons/eye.svg';
//components
import Button from '@/shared/components/Button';
import Input from '@/shared/components/Inputs/Input';
import FormHelperText from '@/shared/components/FormHelperText';
//styles
import {formContentStyle} from './FormContent.styles';
import {USER_TYPE} from '@/utils/enums';
import ForgotPasswordModal from '../../ForgotPasswordModal';
import Modal from '@/shared/components/Modal';

type FormContentProps = {
	userType?: string;
};

const FormContent: FC<FormContentProps> = ({userType}) => {
	const {values, errors, touched, submitForm} = useFormikContext<LoginFormValues>();

	const onSubmitClickHandler = () => submitForm();

	const [showPassword, setShowPassword] = useState(false);
	const [isShowForgotPasswordModal, setIsShowForgotPasswordModal] = useState(false);

	const handleForgotPasswordModalChange = () => setIsShowForgotPasswordModal(!isShowForgotPasswordModal);

	const handleClickShowPassword = () => setShowPassword((show) => !show);

	const isPasswordError = useMemo(
		() => (!!errors.password && !!touched.password) || (!values.password && !!touched.password),
		[values, errors, touched]
	);

	return (
		<Box component={FORM} sx={formContentStyle.form}>
			<Field
				id={FIELD.email}
				name={FIELD.email}
				placeholder={PLACEHOLDER.email}
				label={FIELD_LABEL.email}
				component={Input}
			/>

			<Box sx={formContentStyle.password}>
				<Field
					id={FIELD.password}
					name={FIELD.password}
					placeholder={PLACEHOLDER.password}
					label={FIELD_LABEL.password}
					component={Input}
					type={showPassword ? TEXT : PASSWORD}
					sx={formContentStyle.passwordIcon}
					InputProps={{
						endAdornment: (
							<InputAdornment position={END}>
								<IconButton onClick={handleClickShowPassword} edge={END}>
									{showPassword ? <EyeIcon /> : <EyeSlashIcon />}
								</IconButton>
							</InputAdornment>
						),
					}}
				/>

				{!isPasswordError && userType !== USER_TYPE.ADMIN && (
					<FormHelperText variant={STANDARD} title="Forgot password?" onClick={handleForgotPasswordModalChange} />
				)}
			</Box>

			<Button onClick={onSubmitClickHandler} title={LOG_IN} sx={formContentStyle.button} />
			<Modal onClose={handleForgotPasswordModalChange} open={isShowForgotPasswordModal} sx={formContentStyle.modal}>
				<ForgotPasswordModal onCloseModal={handleForgotPasswordModalChange} />
			</Modal>
		</Box>
	);
};

export default FormContent;
